import {FC} from 'react';
import {useLocation, useParams} from 'wouter';

import {NavigationTabs} from '@mavismart_frontend/components/navigation_tabs';
import {DoorTabs} from '@mavismart_frontend/pages/door_tabs';
import {MobileSearch} from '@mavismart_frontend/pages/mobile_search';
import {AllDoorsList} from '@mavismart_frontend/pages/tabs/all_doors_list';
import {GroupsList} from '@mavismart_frontend/pages/tabs/groups_list';

export const HomeTabs: FC = () => {
  const {doorId} = useParams<{doorId?: string}>();
  const [location] = useLocation();

  if (location.startsWith('/search') && doorId) {
    return <DoorTabs doorId={doorId} baseUrl={`/search/${doorId}`} />;
  }

  return (
    <NavigationTabs
      tabs={[
        {path: '/groups', label: 'groups', view: <GroupsList />, default: true},
        {path: '/doors', label: 'doors', view: <AllDoorsList />},
        {
          path: '/search',
          label: 'search',
          view: <MobileSearch />,
        },
      ]}
    />
  );
};
HomeTabs.displayName = 'HomeTabs';
